module.exports = __webpack_public_path__ + "media/images/firsttime_contents04_sp-b3ccc42bbea70939cbc11186885365fe.png";